/* ============================================================
   KITDOR WISHLIST  —  self-contained, theme-agnostic engine
   ============================================================ */
(function () {
  'use strict';

  var KEY = 'kitdor_wishlist_v2';
  var ACCENT = '#c0563a';
  var SHOP_URL = '/collections/all';   // <-- where the empty-state CTA sends shoppers

  /* ---------- storage ---------- */
  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('kitdor:wishlist:change', { detail: { list: list } }));
  }
  function has(id) {
    id = String(id);
    return read().some(function (it) { return String(it.id) === id; });
  }
  function toggle(item) {
    var list = read();
    var id = String(item.id);
    var i = list.findIndex(function (it) { return String(it.id) === id; });
    if (i > -1) { list.splice(i, 1); } else { list.unshift(item); }
    write(list);
    return i === -1;
  }
  function remove(id) {
    id = String(id);
    write(read().filter(function (it) { return String(it.id) !== id; }));
  }

  /* ---------- read product data off a button's data-attributes ---------- */
  function itemFromEl(el) {
    var d = el.dataset;
    return {
      id: d.wlId,
      handle: d.wlHandle || '',
      title: d.wlTitle || '',
      url: d.wlUrl || '#',
      image: d.wlImage || '',
      price: d.wlPrice || ''
    };
  }

  /* ---------- keep the UI in sync ---------- */
  function syncCounts() {
    var n = read().length;
    document.querySelectorAll('[data-wl-count]').forEach(function (el) {
      el.textContent = n;
    });
  }
  function syncButtons() {
    document.querySelectorAll('[data-wl-toggle]').forEach(function (el) {
      var active = has(el.dataset.wlId);
      el.classList.toggle('is-active', active);
      el.setAttribute('aria-pressed', active ? 'true' : 'false');
      var label = el.querySelector('[data-wl-label]');
      if (label) {
        label.textContent = active
          ? (el.dataset.wlLabelOn || 'Saved')
          : (el.dataset.wlLabelOff || 'Save');
      }
    });
  }

  function escAttr(s) {
    return String(s || '').replace(/"/g, '&quot;');
  }

  /* ---------- render the wishlist PAGE ---------- */
  function renderGrid() {
    var grid = document.querySelector('[data-wl-grid]');
    if (!grid) return;
    var list = read();

    if (!list.length) {
      grid.innerHTML =
        '<div class="kitdor-wl-empty">' +
          '<p class="kitdor-wl-empty__text">' +
            (grid.dataset.wlEmpty || 'Your wishlist is empty.') +
          '</p>' +
          '<a class="kitdor-wl-empty__cta" href="' + SHOP_URL + '">Add products to your wishlist</a>' +
        '</div>';
      return;
    }

    grid.innerHTML = '<div class="kitdor-wl-grid">' + list.map(function (it) {
      var url = escAttr(it.url);
      return '' +
        '<div class="kitdor-wl-card">' +
          '<a class="kitdor-wl-card__media" href="' + url + '">' +
            (it.image ? '<img src="' + escAttr(it.image) + '" alt="" loading="lazy">' : '') +
          '</a>' +
          '<div class="kitdor-wl-card__body">' +
            '<a class="kitdor-wl-card__title" href="' + url + '">' + it.title + '</a>' +
            (it.price ? '<div class="kitdor-wl-card__price">' + it.price + '</div>' : '') +
            '<a class="kitdor-wl-card__buy" href="' + url + '">Buy now</a>' +
            '<button type="button" class="kitdor-wl-card__remove" data-wl-remove="' + escAttr(it.id) + '">Remove</button>' +
          '</div>' +
        '</div>';
    }).join('') + '</div>';
  }

  function refreshAll() { syncCounts(); syncButtons(); renderGrid(); }

  /* ---------- events ---------- */
  document.addEventListener('click', function (e) {
    var toggleBtn = e.target.closest('[data-wl-toggle]');
    if (toggleBtn) {
      e.preventDefault();
      toggle(itemFromEl(toggleBtn));
      refreshAll();
      return;
    }
    var removeBtn = e.target.closest('[data-wl-remove]');
    if (removeBtn) {
      e.preventDefault();
      remove(removeBtn.dataset.wlRemove);
      refreshAll();
    }
  });

  window.addEventListener('storage', function (e) { if (e.key === KEY) refreshAll(); });
  document.addEventListener('kitdor:wishlist:change', refreshAll);

  /* ---------- styles ---------- */
  function injectCSS() {
    if (document.getElementById('kitdor-wl-css')) return;
    var css = document.createElement('style');
    css.id = 'kitdor-wl-css';
    css.textContent = [
      ':root{--kitdor-accent:' + ACCENT + ';}',
      '[data-wl-toggle]{cursor:pointer;background:none;border:0;display:inline-flex;align-items:center;gap:.4em;color:inherit;line-height:1;padding:.25em;}',
      '[data-wl-toggle] svg{width:1.5em;height:1.5em;fill:none;stroke:currentColor;stroke-width:1.8;transition:fill .15s,stroke .15s,transform .15s;}',
      '[data-wl-toggle].is-active svg{fill:var(--kitdor-wl-heart,#e23744);stroke:var(--kitdor-wl-heart,#e23744);}',
      '[data-wl-toggle]:active svg{transform:scale(.85);}',
      '.kitdor-wl-pdp{border:1px solid currentColor;border-radius:999px;padding:.6em 1.1em;font:inherit;}',

      /* grid fills the row, 4-up, rows stretch so cards share equal height */
      '.kitdor-wl-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:2rem 1.25rem;width:100%;align-items:stretch;}',
      '@media (max-width:989px){.kitdor-wl-grid{grid-template-columns:repeat(3,1fr);}}',
      '@media (max-width:749px){.kitdor-wl-grid{grid-template-columns:repeat(2,1fr);gap:1.5rem .75rem;}}',

      /* card fills its column to full height */
      '.kitdor-wl-card{display:flex;flex-direction:column;width:100%;height:100%;}',
      '.kitdor-wl-card__media{display:block;width:100%;aspect-ratio:4/5;overflow:hidden;border-radius:8px;background:rgba(0,0,0,.04);}',
      '.kitdor-wl-card__media img{width:100%;height:100%;object-fit:cover;}',

      /* body grows to fill leftover height; title flex-grows so button sits at bottom */
      '.kitdor-wl-card__body{display:flex;flex-direction:column;gap:.4rem;padding-top:.75rem;flex:1 1 auto;}',
      '.kitdor-wl-card__title{font-size:.95rem;line-height:1.3;text-decoration:none;color:inherit;flex:1 1 auto;}',
      '.kitdor-wl-card__price{font-size:.9rem;opacity:.85;}',
      '.kitdor-wl-card__buy{margin-top:.4rem;display:block;width:100%;box-sizing:border-box;text-align:center;text-decoration:none;font-size:.92rem;font-weight:600;padding:.8em 1em;border-radius:6px;background:var(--color-primary-button-background,#1c1c1c);color:var(--color-primary-button-text,#fff);}',
      '.kitdor-wl-card__remove{align-self:center;background:none;border:0;padding:.5rem 0 0;font-size:.78rem;text-decoration:underline;cursor:pointer;color:inherit;opacity:.65;}',

      /* centered empty state with CTA */
      '.kitdor-wl-empty{display:flex;flex-direction:column;align-items:center;justify-content:center;gap:1rem;text-align:center;padding:3rem 1rem;}',
      '.kitdor-wl-empty__text{opacity:.7;margin:0;font-size:1rem;}',
      '.kitdor-wl-empty__cta{display:inline-block;text-decoration:none;font-weight:600;padding:.8em 1.5em;border-radius:6px;background:var(--color-primary-button-background,#1c1c1c);color:var(--color-primary-button-text,#fff);}'
    ].join('');
    document.head.appendChild(css);
  }

  /* ---------- init ---------- */
  function init() { injectCSS(); refreshAll(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.KitdorWishlist = { read: read, has: has, toggle: toggle, remove: remove, refresh: refreshAll };
})();